import React, { useEffect, useState } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";

type ClockProps = {
  analogSize?: number;
};

export const Clock: React.FC<ClockProps> = ({ analogSize = 40 }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [clock, setClock] = useState(() =>
    new Date().toLocaleTimeString("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    })
  );
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setClock(
        new Date().toLocaleTimeString("pt-BR", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
      );
      setNow(new Date());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const hours = now.getHours() % 12;
  const minutes = now.getMinutes();
  const seconds = now.getSeconds();
  const hourAngle = (360 / 12) * hours + (30 / 60) * minutes;
  const minuteAngle = (360 / 60) * minutes;
  const secondAngle = (360 / 60) * seconds;

  return (
    <Box display="flex" alignItems="center" gap={2}>
      <Box
        sx={{
          px: isMobile ? 1 : 2,
          py: isMobile ? 0.2 : 0.5,
          borderRadius: 2,
          bgcolor: "background.paper",
          color: "text.secondary",
          fontWeight: 600,
          fontSize: isMobile ? 14 : 18,
          boxShadow: 1,
          letterSpacing: 1,
          minWidth: isMobile ? 60 : 90,
          textAlign: "center",
          lineHeight: 1.2,
        }}
      >
        {clock}
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <svg
          width={analogSize}
          height={analogSize}
          viewBox="0 0 40 40"
          style={{ filter: "drop-shadow(0 2px 6px rgba(44,62,80,0.08))" }}
        >
          <circle
            cx="20"
            cy="20"
            r="18"
            fill={theme.palette.background.paper}
            stroke={theme.palette.divider}
            strokeWidth="2"
          />
    
          <line
            x1="20"
            y1="20"
            x2={20 + 7 * Math.sin((Math.PI / 180) * hourAngle)}
            y2={20 - 7 * Math.cos((Math.PI / 180) * hourAngle)}
            stroke={theme.palette.text.primary}
            strokeWidth="3"
            strokeLinecap="round"
          />
      
          <line
            x1="20"
            y1="20"
            x2={20 + 11 * Math.sin((Math.PI / 180) * minuteAngle)}
            y2={20 - 11 * Math.cos((Math.PI / 180) * minuteAngle)}
            stroke={theme.palette.primary.main}
            strokeWidth="2"
            strokeLinecap="round"
          />
       
          <line
            x1="20"
            y1="20"
            x2={20 + 14 * Math.sin((Math.PI / 180) * secondAngle)}
            y2={20 - 14 * Math.cos((Math.PI / 180) * secondAngle)}
            stroke={theme.palette.error.main}
            strokeWidth="1"
            strokeLinecap="round"
          />
          <circle cx="20" cy="20" r="2" fill={theme.palette.primary.main} />
        </svg>
      </Box>
    </Box>
  );
};